module.exports = global["$"] = require("-!/Users/alena/Documents/Developing/testing task/Portfolio/csssr-project-template-master/node_modules/expose-loader/index.js?jQuery!/Users/alena/Documents/Developing/testing task/Portfolio/csssr-project-template-master/node_modules/source-map-loader/index.js!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js
// module id = 2
// module chunks = 0